import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Romina S.',
  age: 34,
  location: 'Córdoba',
  text: 'Siempre sentí que el Reiki era para mí, pero no encontraba un material claro. El MegaPack me dio la estructura que necesitaba. Ahora practico todos los días con confianza.'
}, {
  name: 'Gabriela M.',
  age: 42,
  location: 'Rosario',
  text: 'Tenía miedo de no entender nada, pero todo está explicado tan simple que desde el primer tomo ya estaba practicando. Mis dolores de cabeza crónicos mejoraron muchísimo.'
}, {
  name: 'Soledad P.',
  age: 38,
  location: 'Buenos Aires',
  text: 'Lo compré pensando que era otro curso más, pero me sorprendió la profundidad y la claridad. Mis hijos notan la diferencia en casa. Estoy más tranquila y presente.'
}, {
  name: 'Mariana L.',
  age: 51,
  location: 'Mendoza',
  text: 'A mi edad pensé que era tarde para empezar algo nuevo. El MegaPack me demostró lo contrario. Hoy doy sesiones a mis amigas y me siento realizada.'
}, {
  name: 'Florencia R.',
  age: 29,
  location: 'La Plata',
  text: 'Soy muy escéptica pero decidí probar. La guía de chakras fue reveladora. Entendí cosas de mi cuerpo y emociones que nunca había conectado.'
}];
export function TestimonialsSection() {
  return <section className="bg-white py-24 md:py-32 px-4" data-id="element-268">
      <div className="container mx-auto max-w-5xl" data-id="element-269">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-270">
          <span className="text-amber-500 font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-271">
            Historias Reales
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 leading-tight" data-id="element-272">
            Lo que dicen quienes ya lo tienen
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-273">
          {TESTIMONIALS.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className={`bg-gray-50 rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md hover:border-amber-100 transition-all duration-300 relative group ${idx === TESTIMONIALS.length - 1 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-274">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-amber-100 group-hover:text-amber-200 transition-colors" data-id="element-275" />

              <div className="flex gap-1 mb-6" data-id="element-276">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-277" />)}
              </div>

              <p className="text-gray-700 text-lg leading-relaxed mb-6 font-medium" data-id="element-278">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 pt-6 border-t border-gray-200/60" data-id="element-279">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-white font-bold text-sm shadow-sm" data-id="element-280">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-281">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-282">
                    {t.name}, {t.age} años
                  </p>
                  <p className="text-xs text-gray-500 font-medium" data-id="element-283">
                    {t.location}, Argentina
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}